import CustomDatatableExtension from '../models/custom-datatable-extension';

export const DatatableExtensions: CustomDatatableExtension<any>[] = [];

/**
 * An angular component that is decorated with @DatatableExtension can be used by the datatable via
 * the 'dom' property.
 *
 * @param options The options are:
 *                 - componentElement is a string that must match the selector defined by the component decorator.
 *                 - key is a single character that can be used in the 'dom' property of the datatable.
 * @constructor
 */
export default function DatatableExtension(options: { componentElement: string; key: string; name: string }) {
  return function (target) {
    const extension: CustomDatatableExtension<any> = CustomDatatableExtension.create(
      options.componentElement,
      options.key,
      options.name,
      target
    );

    // Collect all created extensions
    DatatableExtensions.push(extension);
  };
}
